//
// TikTok oEmbed — GET https://www.tiktok.com/oembed?url=https://www.tiktok.com/@<handle>
// Existence + display name + avatar for an exact handle (200 = exists, 400 = no such account).
// Not a search: it only answers for a complete handle. Throttles under burst, so the router
// caches its answers hard and uses it for existence checks only.
//

import { ProviderMiss, type Provider } from '../../router/registry';

export interface TiktokExistence {
	exists: true;
	unique_id: string;
	nickname: string;
	avatar_url: string;
	link: string;
}

export const TOembed: Provider = {
	id: 'tiktok_oembed',
	platform: 'tiktok',
	capabilities: ['exists'],
	family: 'own',
	transport: 'anonymous',
	requiresToken: false,
	seedLatencyMs: 395,
	missStatuses: [400],
	request: (req) => ({
		url: `https://www.tiktok.com/oembed?url=${encodeURIComponent(`https://www.tiktok.com/@${req.query.replace(/^@/, '')}`)}`,
		init: { method: 'GET', headers: { Accept: 'application/json' } },
	}),
	parser: (body, req) => {
		const b: any = body;
		if (!b || typeof b !== 'object') throw new Error('non-JSON body');
		// A nonexistent handle answers HTTP 400 {"message":"Something went wrong","code":400}
		// (mapped to a miss by missStatuses); a 200 body that still carries code 400 is the same answer.
		if (b.code === 400) throw new ProviderMiss('no such account');
		const handle = req.query.replace(/^@/, '');
		return {
			exists: true,
			unique_id: handle,
			nickname: String(b.author_name ?? ''),
			avatar_url: String(b.thumbnail_url ?? ''),
			link: String(b.author_url ?? `https://www.tiktok.com/@${handle}`),
		} satisfies TiktokExistence;
	},
};

export default TOembed;
